import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import { materialTheme } from '../../particles';

import { ButtonProps } from './index';

const MIN_HEIGHT_BY_SIZE: Record<NonNullable<ButtonProps['size']>, number> = {
  small: 32,
  medium: 40,
  large: 48
};

const FONT_SIZE_BY_SIZE: Record<NonNullable<ButtonProps['size']>, number> = {
  small: 13,
  medium: 14,
  large: 15
};

const PADDING_BY_SIZE: Record<NonNullable<ButtonProps['size']>, string> = {
  small: '4px 12px',
  medium: '6px 18px',
  large: '8px 24px'
};

const StyledButton = styled(Button)<ButtonProps>`
  border-color: ${materialTheme.palette.primary.main};
  border-width: 2px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.01em;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background-color 180ms ease, box-shadow 180ms ease, transform 120ms ease,
    border-color 180ms ease, color 180ms ease;

  ${({ size }) => {
    const key = size || 'medium';
    return `
      min-height: ${MIN_HEIGHT_BY_SIZE[key]}px;
      padding: ${PADDING_BY_SIZE[key]};
    `;
  }}

  ${({ size, $fontSize }) =>
    $fontSize ? `font-size: ${$fontSize}rem;` : `font-size: ${FONT_SIZE_BY_SIZE[size || 'medium']}px;`}

  &:focus-visible {
    outline: 2px solid ${materialTheme.palette.secondary.main};
    outline-offset: 2px;
  }

  &.Mui-disabled {
    opacity: 0.55;
  }

  ${({ $hoverColor }) =>
    $hoverColor
      ? ` &:hover {
              background-color: ${$hoverColor};
          }`
      : ``}
`;

export default StyledButton;
